import './asset-card.scss'

import { Space } from '../..'
import { StateCircle } from '../../atoms/circle/StateCircle'

export type AssetCardProps = {
  assetId: string
  assetName: string
  isInUse?: boolean
  isSelected?: boolean
  onClickAsset?: (assetId: string) => void
  prependedRow?: React.ReactNode
}

export const AssetCard = ({
  assetId,
  assetName,
  isInUse,
  isSelected,
  onClickAsset,
  prependedRow
}: AssetCardProps) => (
  <li className={`${isSelected ? 'asset-item-selected' : 'asset-item'}`}>
    <Space isinlineblock ismax pt={3} px={4} onClick={() => onClickAsset(assetId)}>
      {prependedRow}
      <Space
        className={`${isSelected ? 'asset-item-name-selected' : 'asset-item-name'}`}
        mb={prependedRow ? 1 : 3}
      >
        {assetName}
      </Space>
      <Space
        className={`${isSelected ? 'asset-item-id-selected' : 'asset-item-id'}`}
        mb={prependedRow ? 1 : 3}
      >
        {assetId}
        {isInUse && (
          <Space
            isflex
            alignItems="center"
            className="trade-item-status"
            flexDirection="row"
            mt={3}
          >
            <StateCircle state="warning" />
            <div>Asset in use - limited changes allowed</div>
          </Space>
        )}
      </Space>
    </Space>
  </li>
)
